import { render, staticRenderFns } from "./TeamMemberDescriptionCard.vue?vue&type=template&id=5c2a8b68&scoped=true&"
import script from "./TeamMemberDescriptionCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TeamMemberDescriptionCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TeamMemberDescriptionCard.vue?vue&type=style&index=0&id=5c2a8b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a8b68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c2a8b68')) {
      api.createRecord('5c2a8b68', component.options)
    } else {
      api.reload('5c2a8b68', component.options)
    }
    module.hot.accept("./TeamMemberDescriptionCard.vue?vue&type=template&id=5c2a8b68&scoped=true&", function () {
      api.rerender('5c2a8b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/about-us/index/components/MainContent/components/TeamMemberDescriptionCard.vue"
export default component.exports